import NewsletterSubscription from 'newsletter_subscription/scripts/newsletter_subscription'
import DynamicModal from 'modals/scripts/dynamic_modal'
import WebsiteConfigs from 'website_configs/website_configs'

const MODAL_SELECTOR = '#newsletter_subscription_modal'

class NewsletterSubscriptionButton {
  static async init () {
    $('.js-newsletter-subscription-btn').on('click', (e) => {
      const captcha = $(e.currentTarget).find('.d-none.captcha')[0]?.cloneNode(true)

      let captchaElement
      if (captcha) {
        captchaElement = $(captcha).find('[name=captcha]')[0]

        if (captchaElement) {
          captchaElement.className = captchaElement.dataset.class
          captchaElement.id = captchaElement.dataset.id
        }
      }

      const size = captcha ? 'md' : 'sm'
      e.preventDefault()
      const modal = new DynamicModal(MODAL_SELECTOR, { size: size, header_title: WebsiteConfigs.customNewsletterButtonTitle || I18n.t('newsletter_signup') })
      NewsletterSubscription.render(modal.$body, captcha?.innerHTML)

      modal.open()

      if (captchaElement) {
        window.hcaptcha?.render(captchaElement.id)
      }
    })
  }
}

export default NewsletterSubscriptionButton
